import {Layout} from "./Layout.js";

export class CompanyJoinWaitLayout extends Layout {
    template() {
        const {sectionId = ''} = this.$props;
        return `
                <section id="${sectionId}" class="signup-wide-pop">
                    <header class="js-section-header"></header>
                    <article>
                        <div class="pop-main js-contents-main">
                            ${this.getMainTextTemplate()}
                            <div class="req-done-wrap">
                                <img src="/flow-renewal/assets/images/sign-req-complete.png" alt="">
                                <em>${i18next.t(login.adminPending)}</em>
                                <span>${i18next.t(login.adminPendingDesc)}</span>
                             </div>
                            ${this.getNexPageButtonTemplate()}
                            ${this.getJoinCancelButtonTemplate()}
                        </div>
                    </article>
                </section>
               
        `
    }
    setEvent() {
        this.setNextPageButtonEvent();
        this.setJoinCancelButtonEvent();
    }

    getJoinCancelButtonTemplate() {
        const {cancelButton = {}} = this.$props;
        return  Object.values(cancelButton).length > 0  ?  `<button id = "${cancelButton.id}" class="js-cancel-button btn-underline">${Mutil.n2v(cancelButton.text)}</button>` : "";
    }
    setJoinCancelButtonEvent() {
        const {cancelButton = {}} = this.$props;
        if (Object.values(cancelButton).length === 0) {
            return;
        }
        const {
            cancelFunc = Mutil.noop
        } = cancelButton;

        const _cancelFunc = new Mutil.DebounceNThrottle(() => {
            cancelFunc()
        }, 300);

        this.addEvent("click", '.js-cancel-button', (e) => {
            _cancelFunc.debounceAfterStart();
        });
    }
}